module.exports = __webpack_public_path__ + "static/img/save.4ebe07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/save.png
// module id = CNev
// module chunks = 0